/**
 * Carica TUTTE le presenze unificate per TUTTI gli studenti del corso in una sola chiamata
 * Ottimizzato per performance - evita N chiamate API separate
 */
export default async function getAllPresenzeStudenti(username, token, idCorso) {
  const url = `https://app.accademiadelcinema.it/apis_test/getAllPresenzeStudenti.php`;

  try {
    console.log(
      `[getAllPresenzeStudenti] 🔄 Caricamento presenze unificate per corso ${idCorso}`
    );

    const formData = new FormData();
    formData.append("uname", username);
    formData.append("token", token);
    formData.append("id_corso", idCorso);

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.result !== "ok") {
      console.error("[getAllPresenzeStudenti] ❌ Errore:", data.message);
      return {};
    }

    console.log(
      `[getAllPresenzeStudenti] ✓ Caricate presenze per ${
        Object.keys(data.presenze).length
      } studenti`
    );
    return data.presenze; // Oggetto { id_studente: [array presenze], ... }
  } catch (error) {
    console.error("[getAllPresenzeStudenti] ❌ Errore fetch:", error);
    return {};
  }
}
